import { z } from 'zod';

export const validationProgram = z.object({
  new_program_uuid: z.string().min(1, { message: 'Обязательное поле' }),
  change_at: z.string().min(1, { message: 'Обязательное поле' }),
});

export type ProgramParams = z.infer<typeof validationProgram>;